import Login from './Login'
import RecoverPasswordEmail from './RecoverPasswordEmail'
import RecoverPassword from './RecoverPassword'


export default {
    Login,
    RecoverPassword,
    RecoverPasswordEmail,
}